export default __webpack_public_path__ + "static/media/orange-juice@3x.22b8198d.png";